export default async function canNode({ to, next, store }) {
  const dashboardQuery = { path: "/dashboard" };

  await store.dispatch("fetchCurrentNode", to.params.id);
  if (store.getters.hasNodePermission(to.params.id, "view")) {
    next();
  } else {
    next(dashboardQuery);
  }
}
